window.initCiMessage = function($ciMessage, $messageBox) {
    return new Promise((resolve) => {
        if (!window.icubeMessageInitiated) {
            import(ICUBE_MESSAGE).then(() => {
                $ciMessage.icubeMessage({
                    messageBox: $messageBox,
                    messageTemplates: {
                        default: '<span class="flex-xyc text-center primary-bg radius-4px p-10 fs-10px black text-nowrap i-1">{{message}}</span>',
                        box: '<span class="primary-bg radius-4px p-10 fs-10px black i-1 min-w-160">{{message}}</span>',
                        small: '<span class="flex-xyc primary-bg p-10 radius-50p fs-10px black i-1 text-center"><span class="icon icube-icon-check"></span></span>',
                        error_small: '<span class="flex-xyc primary-bg p-10 radius-50p fs-10px black i-1 text-center"><span class="icon icube-icon-times"></span></span>',
                    },
                });
                
                window.$ciMessage = $ciMessage;
                window.icubeMessageInitiated = true;
                
                resolve();
            });
        } else {
            resolve();
        }
    });
}
